module.exports = __webpack_public_path__ + "img/g8.bd64afeb.jpg";